//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.GeometrySetList.js";
import "../CAM/CAM.Topology.js";
import "../no/ObjectList.js";
let d=[[[1,"GeometryList",0,"CAM.GeometrySetList",0],[1,"Topology",0,"CAM.Topology",0]],[[["reloadGeometry"],"InitializeData",{},1,0],[[],"CreateGeometrySet",{R_:{geometrySet:"CAM.GeometrySet"}},0,0],[["templateSet","entities"],"AppendGeometrySet",{R_:{appendedSet:"CAM.GeometrySet"}},2,0],[["sets"],"ExpandSets",{},1,0],[[],"PreselectGeometry",{},0,0],[["namedGeometry"],"AppendNamedGeometry",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.CAM.Geometry = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.Geometry";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;